import script from "./EmbeddedReport.vue?vue&type=script&setup=true&lang=js"
export * from "./EmbeddedReport.vue?vue&type=script&setup=true&lang=js"

import "./EmbeddedReport.vue?vue&type=style&index=0&id=4b182a7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b182a7c"]])

export default __exports__